#import "../fragments/prospector-saved-filter-fragment.graphql"

mutation DeleteFilter($input: FilterDeleteInput!) {
    filterDelete(input: $input) {
        filter {
            ...ProspectorSavedFilterFragment
        }
    }
}
